
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.607 9.67c1.45 0 2.643-1.128 2.643-2.499 0-1.372-1.193-2.5-2.643-2.5h-.378c.289-.414.443-.898.443-1.394C8.672 1.891 7.466.75 6 .75c-1.466 0-2.672 1.141-2.672 2.527 0 .496.154.98.443 1.394h-.378c-1.45 0-2.643 1.128-2.643 2.5 0 1.371 1.193 2.499 2.643 2.499.907 0 1.753-.441 2.237-1.167-.019 1.315-.997 2.456-2.353 2.747h5.475c-1.351-.296-2.321-1.436-2.338-2.747.475.714 1.301 1.153 2.193 1.167z"}})])
          )
        }
      }
    